import React from 'react'
import './styles.scss'

const colorBackground = {
  ONLINE: 'rgba(31,176,130,0.2)',
  VACATION: 'rgba(232, 119, 33,0.2)',
  ABSENT: 'rgba(255,152,59,0.2)',
  DISCONNECTED: 'rgba(197,197,197,0.2)',
  DISABLED: 'rgba(255, 70, 70, 0.2)'
}

const colorText = {
  ONLINE: 'rgba(31,176,130,1)',
  VACATION: 'rgba(232, 119, 33,1)',
  ABSENT: 'rgba(255,152,59,1)',
  DISCONNECTED: 'rgba(197,197,197,1)',
  DISABLED: 'rgba(255, 70, 70, 1)'
}

/**
 *
 * @param {Object} props
 * @param {String} props.text
 * @param {'ONLINE'|'VACATION'|'ABSENT'|'DISCONNECTED'|'DISABLED'} props.color
 * @returns
 */
const StatusTag = (props) => {
  const { text, color: colorProp } = props
  const color = colorProp ? colorProp : 'ONLINE'
  return (
    <div
      className={`status-tag-container`}
      style={{ backgroundColor: colorBackground[color] }}
    >
      <div
        className='status-tag-container__point'
        style={{ backgroundColor: colorText[color] }}
      />
      <span style={{ color: colorText[color] }}>{text}</span>
    </div>
  )
}

export default StatusTag